import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MainDiv = styled.div`
  height: 100vh;
  width: 100vw;
  background: #F7F8F9;
  display: flex;
  color: #1E2228;
`;
export const ColumnDiv = styled.div`
  height: 100vh;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
`;
export const ContentWrapDiv = styled.div`
  height: calc(100vh - 80px);
  overflow-x: scroll;
  margin-top: 80px;
  display: flex;
  flex-direction: column;
`;
export const ContentDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
export const HeaderWrapDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 25px 36px;
  & > div {
    font-size: 24px;
    font-weight: 700;
  }
  & > button {
    background-color: #1B49EA;
    color: #ffffff;
    border-radius: 8px;
    padding: 12px 17px;
    font-size: 14px;
    font-weight: 700;
    display: flex;
    & > div {
      height: 15px;
      overflow: hidden;
      margin-right: 8px;
      font-size: 20px;
      display: flex;
      align-items: center;
    }
  }
`;
export const CardDiv = styled.div`
  background: #FFFFFF;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  margin: 0px 24px auto 18px;
`;
export const InputWrap = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 0px;
  & input {
    width: auto;
    height: 55px;
    border: 1px solid ${props => props.error ? '#E74C3C' : '#c9c9c9'};
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & select {
    width: 600px;
    height: 55px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    width: 600px;
    border: 1px solid #c9c9c9;
    padding: 13px 15px;
    font-family: sans-serif;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const InputTitleDiv = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 10px;
`;
export const InputErrorDiv = styled.div`
  height: 18px;
  font-size: 12px;
  color: #E74C3C;
  padding-top: 2px;
`;
export const InputNewButton = styled.button`
  width:36px;
  height:auto;
  background-color: #ffffff;
  border: 1px solid #1B49EA;
  border-radius: 8px;
  color: #1B49EA;
  font-size: 26px;
  margin-left: 14px;
  text-align:center;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
`;
export const GreyBoxDiv = styled.div`
  background-color: #F7F8F9;
  border-radius: 10px;
  padding: 30px;
  margin: 8px 30px 30px 30px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  & input {
    height: 57px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
  & textarea {
    padding: 12px;
    font-family: sans-serif;
    line-height: 18px;
    border: 1px solid #c9c9c9;
    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;
export const OptionRowDiv = styled.div`
  display: flex;
  & button {
    height: 57px;
    width: 57px;
    border: 1px solid #c9c9c9;
    margin-left: 23px;
    background: #FFFFFF;
    border-radius: 6px;
  }
`;
export const HeadingDiv = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
`;
export const CheckboxDiv = styled.div`
  height: 57px;
  width: 79px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 38px 4px 18px;
  margin-right: 23px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    right: 17px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:hover {
    &:before {
      background-color: ${props => props.active ? '#1B49EA' : '#dcdcdc'};
    }
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    right: 24px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const CheckboxDiv2 = styled.div`
  height: 57px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 4px 10px 4px 10px;
  margin-right: 23px;
  cursor: pointer;
  font-size: 16px;
  user-select: none;
  text-align: left;
  color: #1D252D;
  background-color: #ffffff;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  box-sizing: border-box;
  &:before {
    content: '';
    height: 16px;
    width: 16px;
    position: absolute;
    left: 14px;
    background-color: ${props => props.active ? '#1B49EA' : '#ffffff'};
    border-radius: 50%;
    border: 1px solid ${props => props.active ? '#1B49EA' : '#CCCCCC'};
  }
  &:hover {
    &:before {
      background-color: ${props => props.active ? '#1B49EA' : '#dcdcdc'};
    }
  }
  &:after {
    content: '';
    display: ${props => props.active ? 'block' : 'none'};
    height: 6px;
    width: 3px;
    border-right: 2px solid #ffffff;
    border-bottom: 2px solid #ffffff;
    position: absolute;
    left: 21px;
    margin-bottom: 1px;
    transform: rotate(45deg);
  }
`;
export const NewOptionButton = styled.button`
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #1B49EA;
  padding: 10px;
  color: #1B49EA;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  height: 45px;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
`;

export const UploadTestCases = styled.button`
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #1B49EA;
  padding: 10px;
  color: #1B49EA;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  width: 155px;
  height: 45px;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
  margin: 0 15px;
`

export const SaveWrapDiv = styled.div`
  border-top: 1px solid #ECECEC;
  padding: 30px 30px 45px 30px;
  display: flex;
  align-items: center;
  justify-content: end;
  gap: 12px;
`;

export const SaveButton = styled.button`
  // width: 161px;
  // height: 56px;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background-color: #1B49EA;
`;
export const CancelLink = styled(Link)`
  // width: 161px;
  // height: 56px;
  padding: 6px 16px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1B49EA;
  background-color: #edf0fe;
  text-decoration: none;
`;
export const TestSwitchDiv = styled.div`
  display: flex;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  display: flex;
  align-items: center;
  margin: 0px 30px 16px 30px;
`;
export const SwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 40px;
  height: 24px;
  margin-right: 10px;
  & input {
    opacity: 0;
    width: 0;
    height: 0;
    &:checked ~ span {
      background-color: #21C17A;
    }
    &:checked ~ span:before {
      -webkit-transform: translateX(15px);
      -ms-transform: translateX(15px);
      transform: translateX(15px);
    }
    &:focus ~ span{
      box-shadow: 0 0 1px #21C17A;
    }
  }
  & span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #C4C6CB;
    -webkit-transition: .2s;
    transition: .2s;
    border-radius: 34px;
    &:before {
      position: absolute;
      content: "";
      height: 18px;
      width: 18px;
      left: 4px;
      bottom: 3px;
      background-color: white;
      -webkit-transition: .2s;
      transition: .2s;
      border-radius: 50%;
    }
  }
`;

export const BoilerPlateWrap = styled.div`
  
`

export const BoilerPlateName = styled.p`
  font-size: 16px;
  font-weight: 600;
` 

export const BoilerPlateTextArea = styled.textarea`
  width: 100%;
  height: 220px;
  font-size: 14px;
  margin: 0 0 20px 0;
`

export const CustomInputTextArea = styled.textarea`
  width: 100%;
  height: 120px;
  font-size: 14px;
`

export const BoilerPlateTextAreaLabel = styled.p`
  font-size: 13px;
  line-height: 13px;
  font-weight: 500;
  margin: 0 0 10px;
`


export const CodeAreaWrap = styled.div`
  display: flex;
  align-items: center;
  width: 640px;
  flex-wrap: wrap;
  justify-content: space-between;
`

export const CodeAreaContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 48%;
`

export const ValidCodeButton = styled.button`
  width: 150px;
  height: 60px;
  background-color: #ffffff;
  border-radius: 4px;
  border: 1px solid #1B49EA;
  padding: 10px;
  color: #1B49EA;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  &:hover {
    color: #ffffff;
    background-color: #1B49EA;
  }
`

export const CompileCodeMessage = styled.p`
  margin: 10px auto;
  color: red;
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
`

export const CompiledOutput = styled.p`
  margin: 0 auto;
  height: 120px;
  overflow: scroll;
  border: 1px solid #c9c9c9;
  border-radius: 6px;
  padding: 5px;
  font-size: 13px;
  line-height: 17px;
`

export const InputOutputLinksWrap = styled.div`
  margin-top: 15px;
`

export const LinksDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
`

export const LinkLabel = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 16px;
  color: #000;
  width: 300px;
  text-align: center;
`

export const LinkInput = styled.input`
  width: 300px;
  margin-right: 20px;
`

export const OutputWrap = styled.div`
  width: 300px;
  padding: 10px 5px 10px;
  height: 160px;
  overflow: scroll;
`
export const OutputLabel = styled.p`
  margin: 8px 0 4px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: black;
`


export const OutputDesc = styled.p`
  margin: 4px 0 8px;
  font-size: 14px;
  line-height: 14px;
  font-weight: 500;
  color: red;
`

export const errorMessage = styled.p`
  margin: 10px 0;
  color: red;
  font-size: 16px;
  line-height: 16px;
  font-weight: 600;
`

export const UploadTestCaseLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: #000;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid #c9c9c9;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: "Arial";
  cursor: pointer;
  margin-right: 23px;
  width: 200px;
  justify-content: center;

  input {
    display: none;
  }
`

export const TestCaseToggleButton = styled.button`
  width: 150px !important;
`

export const CoverImageWrapDiv = styled.div`
  width: 600px;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #F6FAFF;
  border: 1px dashed #D9D9D9;
  border-radius: 10px;
  font-size: 12px;
  color: #506D85;
  padding: 20px 0;
    & img {
      width: 16px;
      height: 15px;
      margin-right: 6px;
    }
  
`

export const CoverImageLabel = styled.label`
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  display: flex;
  align-items: center;
  background: #1B49EA;
  border-radius: 4px;
  padding: 5px 10px;
  font-family: "Arial";
  cursor: pointer;
`;

export const CoverImageInput = styled.input`
  display: none;
`;

export const SaveErrorDiv = styled.div`
  font-size: 14px;
  color: #E74C3C;
  padding-top: 2px;
  margin-left: 12px;
`;

export const Image=styled.img`
width: 100px;
height: 100px;
object-fit: cover;
margin-right: 20px;
`;
export const ImageInputWrap= styled.div`
position: relative;
width: 10px;
height: 10px;
margin-right: 20px;

input[type="file"] {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}`;

/* Page & form layout */
export const PageHeader = styled.div`
  padding: 28px 20px 8px;
  width: 100%;
  box-sizing: border-box;
`;

export const BackLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #1B49EA;
  text-decoration: none;
  margin-bottom: 14px;

  &:hover {
    opacity: 0.8;
  }
`;

export const PageTitle = styled.h1`
  font-size: 26px;
  font-weight: 700;
  margin: 0 0 6px;
  color: #1E2228;
`;

export const PageSubtitle = styled.p`
  font-size: 14px;
  color: #6B7280;
  margin: 0;
  line-height: 1.5;
`;

export const FormBody = styled.div`
  padding: 28px 24px 8px;
  width: 100%;
  box-sizing: border-box;
`;

export const FormSection = styled.section`
  margin-bottom: 36px;

  &:last-of-type {
    margin-bottom: 0;
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid #ECECEC;
`;

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #1E2228;
`;

export const SectionDescription = styled.p`
  font-size: 13px;
  color: #6B7280;
  margin: 0;
`;

export const FormRow = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;

  @media (max-width: 960px) {
    grid-template-columns: 1fr;
  }
`;

export const InputWithAction = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;

  & > div:first-child {
    flex: 1;
    min-width: 0;
  }
`;

export const OwnersWrap = styled.div`
  padding-top: 4px;
`;

export const GreyBoxHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 18px;
  padding-bottom: 12px;
  border-bottom: 1px solid #E5E7EB;
`;

export const GreyBoxTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  margin: 0;
  color: #1E2228;
`;

export const GreyBoxHint = styled.span`
  font-size: 12px;
  color: #6B7280;
`;

export const StepCountRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 18px;
`;

export const StepCountLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 16px;
  color: #1e2228;
`;

export const StepRangeWrap = styled.div`
  width: 200px;

  & input[type='range'] {
    -webkit-appearance: none;
    appearance: none;
    display: block;
    width: 100%;
    height: 16px;
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }

  & input[type='range']::-webkit-slider-runnable-track {
    height: 4px;
    background: #d9dde3;
    border-radius: 4px;
  }

  & input[type='range']::-webkit-slider-thumb {
    -webkit-appearance: none;
    width: 16px;
    height: 16px;
    margin-top: -6px;
    border: 0;
    border-radius: 50%;
    background: #1b49ea;
  }
`;

export const StepRangeMarks = styled.div`
  display: flex;
  justify-content: space-between;

  & button {
    width: 16px;
    margin: 0;
    padding: 0;
    border: 0;
    background: none;
    font-size: 13px;
    font-weight: 600;
    line-height: 16px;
    text-align: center;
    color: #6b7280;
    cursor: pointer;
  }

  & button[data-active='true'] {
    color: #1b49ea;
  }
`;

export const OrderingStepInput = styled.textarea`
  width: 100%;
  min-height: 72px;
  padding: 12px 14px;
  border: none;
  resize: vertical;
  box-sizing: border-box;
  background: transparent;
  color: #1e2228;
  font-family: inherit;
  font-size: 14px;
  line-height: 22px;
  white-space: pre-wrap;

  &:focus {
    outline: none;
  }
`;

export const OrderingPreview = styled.div`
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #E5E7EB;
`;

export const OrderingPreviewRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 8px;
  padding: 12px 14px;
  border-radius: 6px;
  background: #F7F8F9;
  font-size: 14px;
  line-height: 22px;
`;

export const OrderingPreviewIndex = styled.div`
  flex-shrink: 0;
  min-width: 22px;
  font-weight: 700;
`;

export const OrderingPreviewText = styled.div`
  flex: 1;
  min-width: 0;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
`;

/* MCQ options */
export const McqOptionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const McqOptionCard = styled.div`
  width: 100%;
  box-sizing: border-box;
  background: ${props => props.active ? '#F8FAFF' : '#FFFFFF'};
  border: 1px solid ${props => props.active ? '#C7D7FE' : '#E5E7EB'};
  border-radius: 10px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  display: flex;
  flex-direction: column;
`;

export const McqOptionToolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 14px;
  background: ${props => props.active ? '#EEF2FF' : '#F9FAFB'};
  border-bottom: 1px solid ${props => props.active ? '#C7D7FE' : '#E5E7EB'};
`;

export const McqOptionToolbarLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`;

export const McqOptionToolbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const McqCorrectToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 6px 10px;
  background: none;
  border: none;
  cursor: pointer;
  border-radius: 8px;

  &:hover {
    background: rgba(27, 73, 234, 0.08);
  }
`;

export const McqRadioOuter = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid ${props => props.active ? '#1B49EA' : '#D1D5DB'};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${props => props.active ? '#1B49EA' : '#FFFFFF'};
  flex-shrink: 0;
`;

export const McqRadioInner = styled.span`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #FFFFFF;
  display: ${props => props.active ? 'block' : 'none'};
`;

export const McqOptionTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #1E2228;
`;

export const McqCorrectBadge = styled.span`
  font-size: 11px;
  font-weight: 700;
  color: #1B49EA;
  background: #FFFFFF;
  border: 1px solid #C7D7FE;
  padding: 4px 10px;
  border-radius: 20px;
`;

export const McqOptionEditorWrap = styled.div`
  width: 100%;
  padding: 12px 16px 16px;
  box-sizing: border-box;

  & > div {
    width: 100% !important;
    max-width: 100% !important;
    margin-bottom: 0 !important;
    box-sizing: border-box;
  }

  .quill {
    width: 100% !important;
    max-width: 100% !important;
  }

  .ql-toolbar.ql-snow {
    border: 1px solid #E5E7EB;
    border-bottom: none;
    border-radius: 8px 8px 0 0;
    background: #FAFBFC;
    flex-wrap: wrap;
  }

  .ql-container.ql-snow {
    border: 1px solid #E5E7EB;
    border-radius: 0 0 8px 8px;
    width: 100%;
    box-sizing: border-box;
  }

  .ql-editor {
    min-height: 100px;
    word-break: break-word;
  }

  .ql-editor img {
    max-width: 100%;
    height: auto;
  }
`;

export const McqFooter = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #E5E7EB;
`;

export const McqFooterHint = styled.span`
  font-size: 13px;
  color: #6B7280;
`;

export const DeleteIconButton = styled.button`
  height: 36px;
  width: 36px;
  flex-shrink: 0;
  border: 1px solid #FECACA;
  background: #FFFFFF;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: #E74C3C;
    background: #FEF2F2;
  }
`;

/* Compiler section (layout only — no logic changes) */
export const SubSectionDivider = styled.div`
  width: 100%;
  margin: 28px 0 20px;
  padding-top: 24px;
  border-top: 1px solid #E5E7EB;
`;

export const SubSectionTitle = styled.h4`
  font-size: 14px;
  font-weight: 700;
  margin: 0 0 4px;
  color: #1E2228;
`;

export const SubSectionHint = styled.p`
  font-size: 12px;
  color: #6B7280;
  margin: 0 0 16px;
`;

export const TestCaseTable = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TestCaseTableHeader = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr 1fr 200px 72px 120px;
  gap: 12px;
  padding: 0 4px 8px;
  font-size: 12px;
  font-weight: 700;
  color: #6B7280;
  text-transform: uppercase;

  @media (max-width: 1100px) {
    display: none;
  }
`;

export const TestCaseRow = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr 1fr 200px 72px 120px;
  gap: 12px;
  align-items: start;
  background: #FFFFFF;
  border: 1px solid #E5E7EB;
  border-radius: 10px;
  padding: 14px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`;

export const TestCaseIndex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #EDF0FE;
  color: #1B49EA;
  font-size: 13px;
  font-weight: 700;
`;

export const TestCaseFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
`;

export const TestCaseFieldLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;

  @media (min-width: 1101px) {
    display: none;
  }
`;

export const TestCaseTextArea = styled.textarea`
  width: 100%;
  min-height: 88px;
  padding: 10px 12px;
  font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.45;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  resize: vertical;
  box-sizing: border-box;
  background: #FAFBFC;
  color: #1E2228;

  &:focus {
    outline: none;
    border-color: #1B49EA;
    background: #FFFFFF;
  }
`;

export const TestCaseControls = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;

  @media (max-width: 1100px) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
`;

export const VisibilityGroup = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;

export const TimeInputWrap = styled.label`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const TimeInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  padding: 0 10px;
  font-size: 13px;
  color: #1E2228;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #1B49EA;
  }
`;

export const TestCaseActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (max-width: 1100px) {
    flex-direction: row;
    flex-wrap: wrap;
  }
`;

export const FileReadRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const ActionRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 8px;
`;

export const CompilerCodeRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  width: 100%;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

export const CompilerCodeMain = styled.div`
  flex: 1;
  min-width: 0;
  width: 100%;
`;

export const CompilerCodeSidebar = styled.div`
  flex: 0 0 320px;
  max-width: 100%;
  width: 320px;

  @media (max-width: 1000px) {
    width: 100%;
    flex: 1;
  }
`;

export const ValidateButtonRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
`;

export const CustomInputBlock = styled.div`
  width: 100%;
  margin-top: 16px;
`;

export const CustomInputLabel = styled.p`
  margin: 0 0 10px;
  font-size: 13px;
  color: #6B7280;
`;

export const SolutionCodeRow = styled.div`
  display: flex;
  gap: 24px;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
`;

export const SolutionCodeMain = styled.div`
  flex: 1;
  min-width: 0;
`;

export const SolutionCodeSidebar = styled.div`
  flex: 0 0 320px;
  max-width: 100%;

  @media (max-width: 1000px) {
    flex: 1;
    width: 100%;
  }
`;

/* ------------------------------- SQL questions ------------------------------- */

export const SqlQueryTextArea = styled.textarea`
  width: 100%;
  min-height: ${props => props.minHeight || '120px'};
  padding: 12px 14px;
  font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  resize: vertical;
  box-sizing: border-box;
  background: #FAFBFC;
  color: #1E2228;

  &:focus {
    outline: none;
    border-color: #1B49EA;
    background: #FFFFFF;
  }
`;

export const SqlRow = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const SqlCheckbox = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 10px;
  height: 48px;
  padding: 0 14px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  background: #FFFFFF;
  color: #1E2228;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  box-sizing: border-box;

  input {
    width: 16px;
    height: 16px;
    margin: 0;
    accent-color: #1B49EA;
    cursor: pointer;
  }
`;

export const SqlInputWrap = styled(InputWrap)`
  width: 100%;

  & input {
    width: 100%;
    height: 48px;
    padding: 0 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box;
    background: #FFFFFF;

    &:focus {
      border: 1px solid #1B49EA;
    }
  }

  & select {
    width: 100%;
    height: 48px;
    padding: 0 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-size: 14px;
    box-sizing: border-box;
    background: #FFFFFF;

    &:focus {
      border: 1px solid #1B49EA;
    }
  }
`;

export const SqlHintRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;

  input {
    flex: 1;
    height: 48px;
    padding: 0 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-size: 13px;
    box-sizing: border-box;

    &:focus {
      outline: none;
      border-color: #1B49EA;
    }
  }
`;

export const SqlSchemaPanel = styled.div`
  margin-bottom: 16px;
`;

export const SqlSchemaToolRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

export const SqlButton = styled.button`
  border: 1px solid #1B49EA;
  background: #FFFFFF;
  color: #1B49EA;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  line-height: 1.3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-height: 36px;
  transition: border-color 0.15s ease, background 0.15s ease, color 0.15s ease;

  &:hover:not(:disabled) {
    background: #1B49EA;
    color: #FFFFFF;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const SqlSchemaToolBtn = styled(SqlButton)`
  border-color: ${(props) => (props.$active ? '#1B49EA' : '#E5E7EB')};
  background: ${(props) => (props.$active ? '#EDF0FE' : '#FFFFFF')};
  color: ${(props) => (props.$active ? '#1B49EA' : '#374151')};

  &:hover:not(:disabled) {
    border-color: #1B49EA;
    color: #1B49EA;
    background: ${(props) => (props.$active ? '#EDF0FE' : '#FFFFFF')};
  }
`;

export const SqlSchemaFormPanel = styled.div`
  margin-top: 12px;
  padding: 14px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SqlSchemaPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 12px;
`;

export const SqlSchemaPreviewActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

export const SqlSchemaTableHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;

  input {
    width: 14px;
    height: 14px;
    margin: 0;
    accent-color: #1B49EA;
    cursor: pointer;
    flex-shrink: 0;
  }

  strong {
    display: block;
    margin-bottom: 0;
    font-size: 12px;
    color: #1B49EA;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  }
`;

export const SqlSchemaTable = styled.div`
  border: 1px solid ${(props) => (props.$selected ? '#1B49EA' : '#E5E7EB')};
  border-radius: 8px;
  background: ${(props) => (props.$selected ? '#F5F7FF' : '#FFFFFF')};
  padding: 10px 12px;
  min-width: 200px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:hover {
    border-color: #1B49EA;
  }

  strong {
    display: block;
    font-size: 12px;
    color: #1B49EA;
    margin-bottom: 6px;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
  }

  span {
    display: block;
    font-size: 12px;
    color: #4B5563;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
    line-height: 1.6;
  }
`;

export const SqlCaseCard = styled.div`
  border: 1px solid ${props => (props.candidateHidden ? '#FDE68A' : '#E5E7EB')};
  background: ${props => (props.candidateHidden ? '#FFFBEB' : '#FFFFFF')};
  border-radius: 10px;
  padding: 16px;
  margin-bottom: 14px;
`;

export const SqlCandidateBadge = styled.span`
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 600;
  color: ${props => (props.hidden ? '#92400E' : '#1B49EA')};
  background: ${props => (props.hidden ? '#FEF3C7' : '#EDF0FE')};
`;

export const SqlVisibilityGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
`;

export const SqlVisibilityLabel = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const SqlCaseHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
  flex-wrap: wrap;
`;

export const SqlCaseTitle = styled.span`
  font-size: 13px;
  font-weight: 700;
  color: #1E2228;
`;

export const SqlVisibilityToggle = styled(SqlButton)`
  border-color: ${(props) => (props.active ? '#1B49EA' : '#E5E7EB')};
  background: ${(props) => (props.active ? '#EDF0FE' : '#FFFFFF')};
  color: ${(props) => (props.active ? '#1B49EA' : '#374151')};

  &:hover:not(:disabled) {
    border-color: #1B49EA;
    color: #1B49EA;
    background: ${(props) => (props.active ? '#EDF0FE' : '#FFFFFF')};
  }
`;

export const SqlCaseGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  @media (max-width: 1000px) {
    grid-template-columns: 1fr;
  }
`;

export const SqlRunBar = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-top: 12px;
`;

export const SqlRunStatus = styled.span`
  font-size: 12px;
  font-weight: 600;
  color: ${props => (props.error ? '#DC2626' : '#059669')};
`;

export const SqlResultTable = styled.div`
  margin-top: 12px;
  max-height: 240px;
  overflow: auto;
  border: 1px solid #E5E7EB;
  border-radius: 8px;

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: 'Menlo', 'Monaco', 'Consolas', monospace;
    font-size: 12px;
  }

  th, td {
    text-align: left;
    padding: 7px 10px;
    border-bottom: 1px solid #F3F4F6;
    white-space: nowrap;
  }

  th {
    background: #F9FAFB;
    color: #6B7280;
    position: sticky;
    top: 0;
  }
`;
/* --------------------------------- BASH --------------------------------- */

export const BashPathField = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  width: 100%;

  input {
    flex: 1;
    min-width: 0;
    height: 44px;
    padding: 0 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-family: 'JetBrains Mono', Menlo, Consolas, monospace;
    font-size: 12.5px;
    box-sizing: border-box;
    background: #FFFFFF;

    &:focus {
      outline: none;
      border-color: #1B49EA;
    }
  }
`;

export const BashUploadButton = styled(SqlButton)`
  height: 44px;
  flex-shrink: 0;
  border-color: #E5E7EB;
  color: #374151;

  img {
    width: 14px;
    height: 14px;
  }
`;

export const BashFileHeader = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns || '200px 1fr 36px'};
  gap: 10px;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.03em;
`;

export const BashFileRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.columns || '200px 1fr 36px'};
  gap: 10px;
  align-items: center;
  margin-bottom: 10px;

  > input {
    width: 100%;
    height: 44px;
    padding: 0 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-family: 'JetBrains Mono', Menlo, Consolas, monospace;
    font-size: 12.5px;
    box-sizing: border-box;
    background: #FFFFFF;

    &:focus {
      outline: none;
      border-color: #1B49EA;
    }
  }
`;

export const BashFieldLabel = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #1E2228;
  margin: 14px 0 8px;
`;

export const BashInfoNote = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  margin-top: 8px;
  padding: 10px 12px;
  border-radius: 8px;
  background: #F5F7FF;
  border: 1px solid #E0E7FF;
  color: #4B5563;
  font-size: 12px;
  line-height: 1.5;

  code {
    font-family: 'JetBrains Mono', Menlo, Consolas, monospace;
    font-size: 11.5px;
    color: #1B49EA;
  }
`;
